export const fetchCountryCode = async (
  setCountryCode: (countryCode: string) => void
) => {
  try {
    const response = await fetch("/api/country");
    if (!response.ok) {
      throw new Error("Error fetching Country Code...");
    }
    const data = await response.json();
    console.debug("Country Code: ", data.countryCode);
    setCountryCode(data.countryCode);
  } catch (error) {
    console.error("Error fetching Country Code...", error);
  }
};
